import { Component, Inject, Input, TemplateRef } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface DialogData {
  header: string;
  content: TemplateRef<any>;
}

/**
 * @title Injecting data when opening a dialog
 */
@Component({
  selector: 'eve-dialog.component',
  templateUrl: 'dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent {


  scrollSubject: Subject<any> = new Subject<any>();

  contentData: any = null;


  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.contentData = Object.assign({}, data, { scrollSubject: this.scrollSubject });
  }
}
